import request from './request.js';

/**
 * @returns {Promise<any>}
 */
function get(invoiceNum) {
    const options = {
        endpoint: `/user/invoices/${ invoiceNum }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    get
};